import { db } from "../../../firebase/firebase-config";

export const SET_REVIEWS = "SET_REVIEWS";

export const getAllReviews = () => (dispatch) => {
  const reviews = [];
  db.collection("reviews")
    .orderBy("order")
    .get()
    .then((snap) => {
      snap.docs.forEach((doc) => reviews.push({ id: doc.id, ...doc.data() }));
      dispatch({ type: SET_REVIEWS, payload: { reviews } });
    })
    .catch(console.error);
};

export const addReview = async (data) => {
  await db.collection("reviews").add({
    name: data.name || "",
    text: data.text || "",
    stars: Number(data.stars) || 5,
    avatarURL: data.avatarURL || "",
    order: Number(data.order) || 0,
  });
};

export const editReview = async (id, data) => {
  await db.collection("reviews").doc(id).update({
    name: data.name || "",
    text: data.text || "",
    stars: Number(data.stars) || 5,
    avatarURL: data.avatarURL || "",
    order: Number(data.order) || 0,
  });
};

export const deleteReview = async (id) => {
  await db.collection("reviews").doc(id).delete();
};
